import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RepairTrackingDefect, RepairTrackingDetails } from '../../interfaces/repair-tracking.interface';
import { LmrServices } from '../../services/lmr.service';

interface RepairTrackingSection extends RepairTrackingDetails {
  title: string;
  isRequote: boolean;
  resultLabel: string;
  defectRows: (RepairTrackingDefect & { value: number | null })[];
}

@Component({
  selector: 'app-repair-tracking-details',
  templateUrl: './repair-tracking-details.component.html',
  styleUrls: ['./repair-tracking-details.component.sass'],
})
export class RepairTrackingDetailsComponent implements OnInit {
  history: RepairTrackingDetails[] = [];
  sections: RepairTrackingSection[] = [];
  tradeId = '';
  status = '';
  finalClassification = '';
  loading = true;
  loadError = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private lmrService: LmrServices,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.tradeId = this.route.snapshot.paramMap.get('tradeId');
    this.lmrService.getRepairTrackingDetails(this.tradeId).subscribe({
      next: response => {
        this.history = response?.items ?? [];
        this.status = response?.status ?? '';
        this.finalClassification = response?.finalClassification ?? '';
        this.sections = this.history.map(calculation => {
          const isRequote = calculation.calculationOrigin?.code === 2;
          const isOriginal = calculation.calculationOrigin?.code === 1;

          return {
            ...calculation,
            isRequote,
            title: isRequote ? 'Reorçamento' : isOriginal ? 'Orçamento de Reparo' : calculation.calculationOrigin?.description || 'Cálculo LMR',
            resultLabel: calculation.isRepairViable
              ? (isRequote ? 'Aprovado' : 'Reparar')
              : (isRequote ? 'Reprovado' : 'Não reparar'),
            defectRows: (calculation.defects?.items ?? []).map(defect => ({
              ...defect,
              value: defect.parts?.length
                ? defect.parts.reduce((total, part) => total + part.partValue + part.laborValue, 0)
                : null,
            })),
          };
        });
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.loadError = true;
        this.toastr.error('Não foi possível carregar o acompanhamento deste trade.');
      },
    });
  }

  currency(value: number): string {
    if (value === null || value === undefined) return '-';
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  openTrade(): void {
    this.router.navigate(['/tvf/pedidos', this.tradeId]);
  }
}
